
import { GetStandardReturnHistoryParameter } from "@dana/Services/StandardReturnStatusService";
import { StandardReturnHistotyStateActions } from "@dana/Store/Data/StandardReturnsStatus/Reducers/StandardReturnsStatusReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";


type HandlerType = Handler<
    GetStandardReturnHistoryParameter,
    DispatchProp<StandardReturnHistotyStateActions>
>;

export const UpdateFilter: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsHistory/UpdateFilter",
        filter: props.parameter,
    });
};


export const chain = [UpdateFilter];

const updateStandardReturnsHistoryFilter = createHandlerChainRunner(chain, "UpdateStandardReturnsHistoryFilter");
export default updateStandardReturnsHistoryFilter;